import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CurrencyPipe, DatePipe, NgClass, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DocumentsService } from '@modules/universal-billing/accounting/documents/documents.service';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { FullNamePipe } from '@common/pipe/full-name.pipe';
import { ButtonModule } from '@primeng/button';
import { ApiService } from '@shared/services/api.service';
import { DefaultService } from '@common/references/default.service';
import {
  BookingAssignService
} from '@modules/universal-billing/accounting/bookings/booking-assign/booking-assign.service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-booking-assign',
  standalone: true,
  imports: [
    CurrencyPipe,
    DatePipe,
    TranslatePipe,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteComponent,
    FullNamePipe,
    ButtonModule,
    NgClass
  ],
  templateUrl: './booking-assign.component.html',
  styleUrl: './booking-assign.component.scss'
})
export class BookingAssignComponent extends BasicForm<any> implements OnChanges {
  @Input() data: any;
  @Input() isEdit: boolean = false;
  @Input() initialDocument: any = null;
  @Output() onAssigned = new EventEmitter();
  public document: any = null;
  form: FormGroup;

  _defaultService: DefaultService<any> = inject(BookingAssignService);
  protected bookingAssignService = inject(BookingAssignService);
  protected documentsService = inject(DocumentsService);
  private api = inject(ApiService);

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      datevBookingId: ['', Validators.required],
      documentId: [null]
    })
  }

  ngOnInit() {
    super.ngOnInit();
    this.init();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

  init() {
    if (this.initialDocument?.document) {
      this.document = this.initialDocument?.document;
      this.getDocumentData(this.document);
      this.form.patchValue({
        documentId: this.document.id,
      })
    }

    if (this.data) {
      this.form.patchValue({datevBookingId: this.data.datevBookingId});
    }
  }

  submitAction(data: any):
    Observable<any> {
    const payload = {
      document_id: this.document?.id,
      datev_booking_id: this.data?.id
    };
    if (!data.documentId) {
      return this.bookingAssignService.delete(this.data.bookingDocument.id);
    } else if (!this.initialDocument?.document) {
      return this.bookingAssignService.insert(payload)
    } else {
      return this.bookingAssignService.put(payload, this.data.bookingDocument.id);
    }
  }

  afterSuccessSubmit(res: any) {
    this.isPending.set(false);
    this.sweetAlertService.success('', "TOAST.TOAST_ASSIGN")
    this.onAssigned.emit();
  }

  override cancel() {
    this.form.patchValue({
      documentId: this.initialDocument?.documentId
    })
    this.getDocumentData(this.initialDocument?.document);
  }

  getDocumentData(doc: any) {
    this.document = doc;
    this.form.patchValue({
      datevBookingId: this.data?.id
    })
  }
}
